const WA_LINK = "https://wa.me/50766132697?text=Hola%2C%20quiero%20agendar%20una%20cita%20con%20el%20Dr.%20Erick%20Tejada";

const infoItems = [
  {
    icon: "ri-map-pin-2-line",
    color: "bg-teal-100",
    iconColor: "text-teal-600",
    title: "Dirección",
    content: "El Dorado, al lado del Do It Center\nCiudad de Panamá, Panamá",
  },
  {
    icon: "ri-time-line",
    color: "bg-emerald-100",
    iconColor: "text-emerald-600",
    title: "Horario de Atención",
    content: "Lunes a Viernes\n9:00 AM – 5:00 PM",
  },
  {
    icon: "ri-phone-line",
    color: "bg-amber-100",
    iconColor: "text-amber-600",
    title: "Teléfono / WhatsApp",
    content: "+507 6613-2697",
    href: "tel:+50766132697",
  },
  {
    icon: "ri-money-dollar-circle-line",
    color: "bg-slate-100",
    iconColor: "text-slate-600",
    title: "Formas de Pago",
    content: "Efectivo y Yappy\nNo se aceptan tarjetas",
  },
];

export default function LocationSection() {
  return (
    <section className="py-14 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span
            className="inline-block text-teal-600 text-xs md:text-sm font-semibold uppercase tracking-wider mb-3"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Cómo llegar
          </span>
          <h2
            className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800 mb-3"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Encuéntranos en{" "}
            <span className="italic font-normal text-teal-600" style={{ fontFamily: "'Lora', serif" }}>
              El Dorado
            </span>
          </h2>
          <p
            className="text-slate-500 text-sm md:text-base max-w-md mx-auto"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Estamos ubicados en El Dorado, Ciudad de Panamá, al lado del Do It Center. Atención con cita previa.
          </p>
        </div>

        {/* Layout: info + map */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-8 items-stretch">
          {/* Info panel */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            {infoItems.map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-4 bg-slate-50 rounded-2xl px-5 py-4 border border-slate-100"
              >
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-xl ${item.color} flex-shrink-0 mt-0.5`}
                >
                  <i className={`${item.icon} ${item.iconColor} text-lg`}></i>
                </div>
                <div>
                  <p
                    className="font-semibold text-slate-800 text-sm mb-0.5"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {item.title}
                  </p>
                  {item.href ? (
                    <a
                      href={item.href}
                      className="text-slate-600 text-sm hover:text-teal-600 transition-colors whitespace-pre-line cursor-pointer"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {item.content}
                    </a>
                  ) : (
                    <p
                      className="text-slate-600 text-sm whitespace-pre-line"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {item.content}
                    </p>
                  )}
                </div>
              </div>
            ))}

            {/* CTA */}
            <a
              href={WA_LINK}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-4 rounded-2xl transition-all text-sm whitespace-nowrap cursor-pointer mt-auto"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Agendar Cita por WhatsApp
            </a>
          </div>

          {/* Map */}
          <div className="lg:col-span-3 rounded-2xl overflow-hidden border border-slate-100 min-h-[320px] md:min-h-[420px]">
            <iframe
              title="Clínica de Colposcopia Dr. Erick Tejada - El Dorado, Ciudad de Panamá"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d491.8!2d-79.5365202!3d9.0069777!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8faca9004f2fa099%3A0x6776dd1fc2956426!2sCl%C3%ADnica%20de%20Colposcopia%20Dr.%20Erick%20Tejada!5e0!3m2!1ses!2spa!4v1700000000000!5m2!1ses!2spa"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "320px" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
